import { DateTime } from 'luxon';

export interface ActivityCalendarEvent {
  end: Date;
  id: string;
  start: Date;
  templateId?: string;
  title: string;
}

export const convertActivitiesToCalendarEvents = (activities, censoredWords): ActivityCalendarEvent[] => activities
  .map(activity => ({
    id: activity.id,
    templateId: activity.templateId,
    title: censoredWords
      .some(censoredWord => (activity.comments || '').toLowerCase().includes(censoredWord.toLowerCase()))
      ? '*****'
      : activity.comments,
    start: DateTime.fromISO(activity.startTime).toJSDate(),
    end: DateTime.fromISO(activity.endTime).toJSDate(),
  }));
